import { render, staticRenderFns } from "./rolemanage.vue?vue&type=template&id=3e59370e"
import script from "./rolemanage.vue?vue&type=script&lang=js"
export * from "./rolemanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports